module.exports = __webpack_public_path__ + "img/linux-professional-institute.776374ad.png";